export default ({ itemDescription, itemCategory, itemComment, repairCost = 0, issue }) => ({
  itemDescription,
  itemComment,
  blind_item: true,
  item_desc: itemDescription,
  item_category: itemCategory,
  item_name: itemDescription,
  item_qty: 1,
  remaining_qty: 1,
  return_qty: 1,
  returned: true,
  return_desc: `Repair Reason: ${issue.display_name}`,
  itemStatus: `Repair Reason: ${issue.display_name}`,
  selected: true,
  total_price: repairCost,
  repair_reason_fee: repairCost,
  user_comment: itemComment,
});
